$(document).ready(function() {
  if ($(window).width() > 768) {
	$(window).scroll(function(){
      var sticky = $('#site-header'),
          scroll = $(window).scrollTop(),
      	  container = $('#shopify-section-header'),
          sticky2 = $('.sticky-menu');

      if (scroll >= 100){
        sticky.addClass('sticky');
        sticky2.addClass('sticky').delay( 1000 ).css("top",sticky.height());
        container.addClass('has-sticky');
      }
      else {
        sticky.removeClass('sticky');
        sticky2.removeClass('sticky');
        sticky2.css("top",0);
        container.removeClass('has-sticky');
      }
      
    });
  }
});
